var chunkToChildrenMap = {"8074":["6851","4352","3302","3831"],"1591":["6851","4352","3302","3831"],"8783":["6851","4352","3302","3831"],"9626":["6851","4352","3302","3831"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};